import api from './api';

function getHost() {
  const base = api.defaults.baseURL || '';
  try {
    const u = new URL(base);
    return `${u.protocol}//${u.host}`;
  } catch {
    return '';
  }
}

function buildHeader(refererPath) {
  const host = getHost();
  const lang = localStorage.getItem('vd-lang') || 'es_es';
  return {
    acceptLanguage: "es-ES",
    externalReferer: `${host}/login`,
    lang,
    referer: `${host}${refererPath}`,
    userAgent: "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/147.0.0.0 Safari/537.36",
    product: "Gecko",
    platform: "Win32",
    vendor: "Google Inc.",
    token: null,
    version: null
  };
}

export const dashboardService = {
  async getSegmentMetadata(segmentId) {
    if (!segmentId) throw new Error('Missing segmentId for metadata request.');

    const timestamp = Date.now();
    const payload = {
      requestHeader: buildHeader(`/segment/segment-management/search-segment/get/${segmentId}`),
      requestContent: { id: segmentId }
    };

    try {
      const response = await api.post(`${timestamp}/segment/builder/get`, payload);
      return response.data;
    } catch (err) {
      if (err.response?.status === 401) {
        const fallback = await api.post(`${timestamp}/segment/dashboard/get`, payload);
        return fallback.data;
      }
      throw err;
    }
  },

  async getDashboardStats(segmentId, jsonData) {
    if (!segmentId || !jsonData) {
      throw new Error('Missing segmentId or jsonData for the request.');
    }

    const timestamp = Date.now();
    const payload = {
      requestHeader: buildHeader(`/segment/segment-management/search-segment/get-dashboard/${segmentId}`),
      requestContent: {
        id: segmentId,
        code: null,
        jsonData: Array.isArray(jsonData) ? jsonData : [jsonData]
      }
    };

    const response = await api.post(`${timestamp}/segment/dashboard/task`, payload);
    return response.data;
  }
};
